import React, { Component } from "react";
import { Tooltip as ReactToolTip} from "react-tooltip"
import { Link } from "react-router-dom";
import Layout from "./../layouts/Index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Switch from "react-switch";
import { Row, Col, Container, ListGroup, Table } from "react-bootstrap";
import { showUser } from "./../../store/actions/UserActions";
import {
  editBid
} from "./../../store/actions/BidActions";
import { instance } from "./../../helpers/instance";
import BlockLoader from "./../contentloaders/BlockLoader";

import {
  Chart as ChartJS,
  CategoryScale,
  BarElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

class Show extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      monthly_affiliate_earnings: [],
    };
  }

  componentDidMount = async () => {
    const {
      match: { params },
    } = this.props;

    this.setState({ loading: true });

    const result = await this.props.showUser(params.id);

    if (result) {
      this.setState({ loading: false });
      this.fetchAffiliate(result?.affiliate_code);
    }
  };

  fetchAffiliate = async (code) => {
    try {
      this.setState({ loading: true });
      let result = await instance.get(`affiliates_tracking/${code}`);
      if (result?.data) {
        this.setState({ monthly_affiliate_earnings: result?.data || [] });
      }
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }
  };

  handleStatusChanges = async (status_type, id, checked) => {
    try {
      let payload = {};
      let toastText = "";
      if (status_type === "status") {
        payload.status = checked ? 1 : 0;
        toastText = "Payment status";
      } else if (status_type === "shipping_status") {
        payload.shipping_status = checked ? 1 : 0;
        toastText = "Shipping Fee Payment status";
      } else if (status_type === "is_collected") {
        payload.is_collected = checked ? 1 : 0;
        toastText = "Collection status";
      }
      if (checked) {
          if (!window.confirm("This action is final and cannot be reversed. Are you sure you want to proceed?")) {
            return;
          }
        }
      const result = await this.props.editBid(id, payload);
      if (result) {
        // Refresh the only the affected bid
        const updatedBid = this.props.users.user.bids.find(bid => bid.id === id);
        if (updatedBid) {
          updatedBid[status_type] = checked ? 1 : 0;
        }
        this.setState({ loading: false }, () => {
          toast.success(toastText + " updated successfully", { position: "bottom-center" });
        });
      }
    } catch (error) {
      toast.error("Error updating bid status: " + error.response.data.message, { position: "bottom-center" });
    }
  };

  render() {
    const {
      users: { user },
    } = this.props;

    const { loading, monthly_affiliate_earnings } = this.state;

    let earnings = [...monthly_affiliate_earnings] || [];

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
          <Container>
            <Row>
              {
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    marginBottom: "1em",
                  }}
                >
                  <h3>User Details</h3>
                </Col>
              }
              {loading && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    marginBottom: "1em",
                  }}
                >
                  <BlockLoader
                    width="100%"
                    height="400px"
                    innerWidth="100%"
                    innerHeight="100%"
                    style={{ marginBottom: "2em" }}
                  />
                </Col>
              )}

              {!loading && (
                <Col sm="12">
                  <ListGroup>
                    <ListGroup.Item style={{ display: "inline-block" }}>
                      <span style={{ fontWeight: "bold" }}>Firstname: </span>{" "}
                      <span>{user.first_name}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>Lastname: </span>{" "}
                      <span>{user.last_name}</span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>Phone Number: </span>{" "}
                      <span>
                        {user.msisdn !== undefined ? user.msisdn : "N/A"}
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>Username: </span>
                      <span>
                        {user.username !== undefined ? user.username : "N/A"}
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>
                        Email Address:{" "}
                      </span>
                      <span>
                        {user.email !== undefined ? user.email : "N/A"}
                      </span>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <span style={{ fontWeight: "bold" }}>Date Joined: </span>
                      <span>
                        {new Date(user.date_created).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric"
                        })
                      }
                      </span>
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
              )}

              {!loading && user.bids !== undefined && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    marginBottom: "1em",
                    marginTop: "1em",
                  }}
                >
                  <h3>User Bids</h3>
                </Col>
              )}
              <Col sm="12">
                {!loading && user.bids !== undefined && (
                  <div style={{ overflowX: "auto" }}>
                    <Table
                      striped
                      bordered
                      hover
                      size="lg"
                      variant="light"
                      responsive="sm"
                      className="users-table"
                    >
                      <thead>
                        <tr>
                          <th>#</th>

                          <th>Product</th>

                          <th>MOQ</th>

                          <th>Bid Number</th>

                          {/* <th>Bid Attributes</th> */}

                          <th>Quantity</th>

                          <th>Amount (KES)</th>

                          <th>Payment Status</th>

                          <th>Date Arrived</th>

                          <th>Shipping Fee (KES)</th>

                          <th>Shipping Payment Status</th>

                          <th>Collection Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {user.bids.map((bid, i) => (
                          <tr key={i}>
                            <td data-label="#">{i + 1}</td>

                            <td data-label="Product">
                              <div className="inline-flex items-center gap-1">
                                <Link to={`/admin/products/${bid.product[0].id}`} data-tooltip-id="product-image-tooltip" data-tooltip-html={
                                    bid.product[0].images.length > 0
                                      ? `<img src="${bid.product[0].images[0]}" alt="${bid.product[0].name}" style="width: 200px; height: auto;"/>`
                                      : `<span>No image available</span>`
                                  }
                                  data-tooltip-placement="right">
                                  {bid.product[0].name}
                                </Link>
                              </div>
                              <ReactToolTip id="product-image-tooltip"/>
                            </td>

                            <td data-label="MOQ">
                              <Link to={`/admin/moqs/${bid.moq_id}`}>{bid.moq[0].moq_number}</Link>
                            </td>

                            <td data-label="Bid Number">
                              <div className="inline-flex items-center gap-1">
                                <Link to={`/admin/bids/${bid.id}`}
                                  data-tooltip-id="bid-attributes-tooltip"
                                  data-tooltip-html={
                                    bid.bid_attributes
                                      .filter(attr => attr && (attr.colors || attr.sizes))
                                      .map(attr => {
                                        const color = attr.colors?.label || "";
                                        const size = attr.sizes?.label ? `size ${attr.sizes.label}` : "";
                                        return `${attr.quantity} ${color} ${size}`;
                                      })
                                      .join("<br/>")
                                    }
                                    data-tooltip-placement="right">
                                    {bid.bid_number}
                                  </Link>
                              </div>
                              <ReactToolTip id="bid-attributes-tooltip"/>
                            </td>

                            <td data-label="Quantity">{bid.quantity}</td>

                            <td data-label="Amount (KES)">{bid.amount.toLocaleString("en-US")}</td>

                            <td data-label="Payment Status">
                              <Switch
                                    onChange={(checked) => this.handleStatusChanges("status", bid.id, checked)}
                                    checked={bid.status === 1 ? true : false}
                                    disabled={bid.status === 1 || bid.moq_fill_status !== "full" || bid.is_collected === 1 || bid.moq_order_status === "placed"}
                                  />

                              {bid.status === 2 && "Collected"}
                            </td>

                            <td data-label="Date Arrived">
                              {!bid.order || bid.order.length === 0 ? (
                                "Order not placed"
                              ) : bid.order[0].status === "Goods arrived at Litudian - Ready to collect" ? (
                                (() => {
                                  const arrivalDate = new Date(bid.order[0].date_goods_arrived);
                                  const daysAgo = Math.floor((Date.now() - arrivalDate.getTime()) / 86400000);
                                  const isOverdue = bid.is_collected === 0 && daysAgo > 30;
                                  return (
                                    <>
                                      {arrivalDate.toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                      })}{" "}
                                      (
                                      <span className={`fw-bold ${isOverdue ? "text-danger" : ""}`}>
                                        {daysAgo} days ago
                                      </span>
                                      )
                                    </>
                                  );
                                })()
                              ) : bid.order[0].eta ? (
                                `Expected ${new Date(bid.order[0].eta).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })}`
                              ) : (
                                "Not Arrived Yet"
                              )}
                            </td>

                            <td data-label="Shipping Fee (KES)">
                              {bid.total_shipping === null
                                ? "N/A"
                                : bid.total_shipping.toLocaleString("en-US")}
                            </td>

                            <td data-label="Shipping Payment Status">
                              <Switch
                                onChange={(checked) => this.handleStatusChanges("shipping_status", bid.id, checked)}
                                checked={bid.shipping_status === 1 ? true : false}
                                disabled={bid.moq_order_status !== "placed" || 
                                  bid.is_collected === 1 || 
                                  bid.shipping_status === 1 || 
                                  bid.status === 0 || 
                                  bid.delivery_status === 1 || 
                                  bid.is_collected === 1 ||
                                  (bid.order !== undefined && bid.order.length > 0 && bid.order[0].status !== "Goods arrived at Litudian - Ready to collect")}
                              />
                            </td>
                            <td data-label="Collection Status">
                              {bid.delivery_status === 1 ? (
                                <span
                                style={{
                                  color: "green"
                                }}
                                >
                                Delivered
                                </span>
                              ) : (
                                <Switch
                                  onChange={(checked) => this.handleStatusChanges("is_collected", bid.id, checked)}
                                  checked={bid.is_collected === 1 ? true : false}
                                  disabled={bid.status === 0 || bid.shipping_status === 0 || bid.is_collected === 1}
                                />
                              )}
                              </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    </div>
                )}
              </Col>

              {!loading && earnings?.length > 0 && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    marginBottom: "1em",
                    marginTop: "1em",
                  }}
                >
                  <h3>Monthly Affiliates Earnings</h3>
                </Col>
              )}
              {!loading && earnings?.length > 0 && (
                <Col
                  sm="12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    marginBottom: "1em",
                    marginTop: "1em",
                    height: "350px",
                  }}
                >
                  <Bar
                    style={{ width: "100%" }}
                    options={{
                      scales: {
                        y: {
                          beginAtZero: true,
                          title: {
                            display: true,
                            text: "Earnings in KES",
                          },
                        },
                        x: {
                          beginAtZero: true,
                          title: {
                            display: true,
                            text: "Month of the year (last 12 months)",
                          },
                          offset: true,
                          grid: {
                            offset: true,
                          },
                          ticks: {
                            align: "center",
                          },
                          barPercentage: 0.1,
                          categoryPercentage: 0,
                        },
                      },
                      maintainAspectRatio: true,
                      responsive: true,
                      plugins: {
                        tooltip: {
                          callbacks: {
                            label: (tooltipItem, data) => {
                              // Access the index of the hovered bar
                              const index = tooltipItem.dataIndex;
                              // Access the data and index of the current bar
                              const earning = earnings[index] || null;

                              if (earning?.status === 1)
                                return `${Math.trunc(earning?.sum)} (paid out)`;
                              return `${Math.trunc(
                                earning?.sum
                              )} (not paid out)`;
                            },
                          },
                        },
                        legend: {
                          position: "top",
                          display: false,
                        },
                        title: {
                          display: false,
                          text: "",
                        },
                      },
                    }}
                    data={{
                      labels: [
                        ...earnings?.map(
                          (a) => `${a?.month_created}, ${a?.year_created}`
                        ),
                      ],
                      datasets: [
                        {
                          label: "",
                          data: [...earnings?.map((a) => a?.sum)],
                          backgroundColor: (context) => {
                            // Access the data and index of the current bar
                            const value = earnings[context.dataIndex]?.status;
                            // Set background color based on your condition (status)
                            return value === 1 ? "green" : "orange";
                          },
                        },
                      ],
                    }}
                  />
                </Col>
              )}
            </Row>
          </Container>
        </Col>
        <style>{`
        @media (max-width: 767px) {
        .users-table thead {
          display: none;
        }
        .users-table, .users-table tbody, .users-table tr, .users-table td {
          display: block;
          width: 100%;
        }
        .users-table tr {
          margin-bottom: 1rem;
          border-bottom: 2px solid #dee2e6;
        }
        .users-table td {
          text-align: right;
          padding-left: 50%;
          position: relative;
          border: none;
          border-bottom: 1px solid #dee2e6;
        }
        .users-table td:before {
          content: attr(data-label);
          position: absolute;
          left: 0;
          width: 50%;
          padding-left: 1rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
        }
        }
      `}</style>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.users,
  };
};

export default connect(mapStateToProps, { showUser, editBid })(Show);
